<template>
  <router-view />
</template>

<script>
  import Vue from 'vue'

  import TabbedHomeView from './TabbedHomeView'

  export default {
    name: 'Home',
    components: { TabbedHomeView },
    created () {
      Vue.AppInsights.trackPageView('Home page', '/')
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .btn {
    border-radius: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue